export default "__VITE_ASSET__Cf4Hee0Z__"